module.exports = __webpack_public_path__ + "static/media/image-0.1a35cefb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/company/image-0.jpg
// module id = 494
// module chunks = 0